var map = {
	"./3d_payment_deadline.svg": "10d4",
	"./3ds.png": "e679",
	"./ada.svg": "e645",
	"./arrow-reload-horizontal-sharp.svg": "686d",
	"./arrow.svg": "97c6",
	"./bg.png": "601a",
	"./bg2.png": "5b1f",
	"./btc.svg": "93f1",
	"./chatting.svg": "52ba",
	"./check.svg": "5621",
	"./close.svg": "cf5a",
	"./customer-service.svg": "9164",
	"./dash.svg": "383e",
	"./decor.svg": "7d72",
	"./doc.svg": "0038",
	"./doc1.svg": "3fca",
	"./doc2.svg": "2da7",
	"./down2.svg": "a12b",
	"./earth.svg": "8674",
	"./ellipse.svg": "d625",
	"./eth.svg": "f388",
	"./exchange-arrows.svg": "0bd4",
	"./exchange.svg": "1728",
	"./facebook.svg": "4df1",
	"./favicon.png": "621a",
	"./folder.svg": "d27a",
	"./footer-bg.jpg": "cf55",
	"./instagram.svg": "0086",
	"./logo.svg": "4d87",
	"./ltc.svg": "a7ff",
	"./mc.svg": "a0cc",
	"./methods/blik.svg": "48d3",
	"./methods/eps.svg": "c884",
	"./methods/giropay.svg": "afff",
	"./methods/trustly.svg": "58cf",
	"./reviews/1.svg": "9c4d",
	"./reviews/2.svg": "6e1b",
	"./reviews/3.svg": "a540",
	"./security.svg": "fc1c",
	"./shield.svg": "a74c",
	"./stopwatch.svg": "bcb8",
	"./time.svg": "b551",
	"./trx.svg": "f3ef",
	"./twitter.svg": "9195",
	"./usdc.svg": "ba84",
	"./usdt.svg": "db2e",
	"./user.svg": "ff95",
	"./visa-logo.svg": "c879",
	"./visa.svg": "70b9",
	"./xrp.svg": "e303"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";